import { downloadBlob } from '@shared/utils'

const ISO_DATE_LENGTH = 10

/**
 * Triggers a browser download for the CSV blob the BE streamed back.
 *
 * Filename is `fiat-transactions-<YYYY-MM-DD>.csv` using today's local
 * date — matches the server-side `Content-Disposition` filename so
 * shared screenshots are consistent.
 */
export function downloadFiatTransactionsCsv(blob: Blob): void {
  const fileNameDate = new Date().toISOString().slice(0, ISO_DATE_LENGTH)
  const csvBlob = blob instanceof Blob ? blob : new Blob([blob], { type: 'text/csv;charset=utf-8' })
  downloadBlob(csvBlob, `fiat-transactions-${fileNameDate}.csv`)
}
